export default {
  sebsutiveWord() {
    return [
      "大傻逼", "傻逼", "煞笔", "沙比",
    ];
  }
}
